module.exports = __webpack_public_path__ + "static/media/logo-no-circle.bf153064.svg";